import React from 'react';

import './MenuModal.css';

export default function MenuModal({ closeModal, closeUnderlayer }) {

    // const closeCurrentModal = () => {


    //     const menuModalAnimation = document.getElementById('Menu-Modal')
    //     const navigationBarMenuModalButtonColor = document.getElementById('NavigationBar-MenuModal-Button')
    //     const navigationBarMenuModalButtonPTag = document.getElementById('NavigationBar-MenuModal-Button-P-Tag')
    //     menuModalAnimation.className = 'Modal-Colors MenuModal-Animation-Closed MenuModal-Position MenuModal-Position MenuModal-Shape MenuModal-Dimensions'
    //     navigationBarMenuModalButtonColor.className = 'NavigationBar-ModalButton-Color-Closed NavigationBar-Buttons-Dimensions'
    //     navigationBarMenuModalButtonPTag.textContent = 'Open Menu'

    //     const modalUnderLayerAnimation = document.getElementById('Modal-Underlayer')
    //     modalUnderLayerAnimation.className = 'Underlayer-Closed'
    //     setTimeout(() => {
    //         closeModal()
    //         closeUnderlayer()
    //     }, 285)
    // }

    return (
        <section id='Menu-Modal' className="Modal-Colors MenuModal-Animation-Opened MenuModal-Position MenuModal-Shape MenuModal-Dimensions">

            <br />
            <div className="Modal-Flex-Row">


                <a href="mailto:david.crockett.1069@gmail.com"><img src={require(`../icons/eMail.png`)} className="App-Icon" alt="email icon" /></a>

                <a href="tel:8013501056"><img src={require(`../icons/phone.png`)} className="App-Icon" alt="phone icon" /></a>

                <a href="https://www.linkedin.com/in/david-crockett-252497211/" target="_blank" rel="noreferrer"><img src={require(`../icons/linkedin.png`)} className="App-Icon" alt="linked icon" /></a>


                <a href="https://github.com/CastroOlympias" target="_blank" rel="noreferrer"><img src={require(`../icons/github.png`)} className="App-Icon" alt="git hub icon" /></a>


                <a href={require(`../../../assets/documents/David_Crockett_Full_Stack_Web_Developer.pdf`)}
                    target="_blank" rel="noreferrer"><img src={require(`../icons/resume.png`)} className="App-Icon" alt="resume icon" /></a>

            </div>
            <br />

        </section>
    )
}